import Vue from 'vue'
import App from './App'
import router from './router'
import { BarChart } from 'vue-morris'
import { LineChart } from 'vue-morris'
import { store } from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts);

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);



// Kneexpert components test
import LayoutHeader from '@/components/kneexpert/layouts/Header'
import HomeBanner from '@/components/kneexpert/HomeBanner'
import Bodypart from '@/components/kneexpert/Bodypart'
import Cat from '@/components/kneexpert/Cat'
import HeaderAdmin from '@/components/layouts/HeaderAdmin'
import LayoutFooter from '@/components/layouts/Footer'
import Sidebar from '@/components/layouts/doctors/SideBar'
import Sidebar1 from '@/components/layouts/patient/SideBar'
import Sidebar2 from '@/components/layouts/hospital/SideBar'
import Specialities from '@/components/Specialities'
import Loader from '@/components/Loader'
import Loader1 from '@/components/kneexpert/layouts/Loader'

/** Breadcrumbs **/
import BreadCrumb from '@/components/breadcrumb/Dashboard'
import BreadCrumb1 from '@/components/breadcrumb/Appointments'
import BreadCrumb2 from '@/components/breadcrumb/MyPatients'
import BreadCrumb3 from '@/components/breadcrumb/ScheduleTimings'
import BreadCrumb4 from '@/components/breadcrumb/Invoices'
import BreadCrumb5 from '@/components/breadcrumb/Reviews'
import BreadCrumb6 from '@/components/breadcrumb/ProfileSettings'
import BreadCrumb7 from '@/components/breadcrumb/SocialMedia'
import BreadCrumb8 from '@/components/breadcrumb/ChangePassword'
import BreadCrumb9 from '@/components/breadcrumb/DoctorProfile'
import BreadCrumb10 from '@/components/breadcrumb/SearchDoctor'
import BreadCrumb11 from '@/components/breadcrumb/DoctorBlog'
import BreadCrumb12 from '@/components/breadcrumb/AddBlog'
import BreadCrumb13 from '@/components/breadcrumb/BlogDetails'
import BreadCrumb14 from '@/components/breadcrumb/BlogList'
import BreadCrumb15 from '@/components/breadcrumb/BlogGrid'
import BreadCrumb16 from '@/components/breadcrumb/Booking'
import BreadCrumb17 from '@/components/breadcrumb/Checkout'
import BreadCrumb18 from '@/components/breadcrumb/Favourites'
import BreadCrumb19 from '@/components/breadcrumb/AddDependent'
import BreadCrumb20 from '@/components/breadcrumb/Pharmacy'
import BreadCrumb21 from '@/components/breadcrumb/PharmacyDetails'
import BreadCrumb22 from '@/components/breadcrumb/PharmacySearch'
import BreadCrumb23 from '@/components/breadcrumb/Product'
import BreadCrumb24 from '@/components/breadcrumb/ProductDescription'
import BreadCrumb25 from '@/components/breadcrumb/Cart'
import BreadCrumb26 from '@/components/breadcrumb/PaymentSuccess'
import BreadCrumb27 from '@/components/breadcrumb/Calender'
import BreadCrumb28 from '@/components/breadcrumb/Components'
import BreadCrumb29 from '@/components/breadcrumb/InvoiceView'
import BreadCrumb30 from '@/components/breadcrumb/Blank'
import BreadCrumb31 from '@/components/breadcrumb/EditDependent'
import BreadCrumb32 from '@/components/breadcrumb/Profile'
import BreadCrumb33 from '@/components/breadcrumb/AddPrescription'
import BreadCrumb34 from '@/components/breadcrumb/AddBilling'
import BreadCrumb35 from '@/components/breadcrumb/EditPrescription'
import BreadCrumb36 from '@/components/breadcrumb/EditBilling'
import BreadCrumb37 from '@/components/breadcrumb/EditBlog'
import BreadCrumb38 from '@/components/breadcrumb/TermCondition'
import BreadCrumb39 from '@/components/breadcrumb/PrivacyPolicy'

import BreadCrumb40 from '@/components/breadcrumb/PatientEncounter'
import BreadCrumb41 from '@/components/breadcrumb/MyTreatment'
import BreadCrumb42 from '@/components/breadcrumb/Testimonial'
import BreadCrumb43 from '@/components/breadcrumb/Dependent'
import BreadCrumb44 from '@/components/breadcrumb/MyEncounter'
import BreadCrumb45 from '@/components/breadcrumb/MyExecercise'
import BreadCrumb46 from '@/components/breadcrumb/Master'
import BreadCrumb47 from '@/components/breadcrumb/HospitalAppointment'
import BreadCrumb48 from '@/components/breadcrumb/PatientReceipt'
import BreadCrumb49 from '@/components/breadcrumb/DoctorReceipt'
import BreadCrumb50 from '@/components/breadcrumb/DoctorReceiptDetail'
import BreadCrumb51 from '@/components/breadcrumb/PatientReceiptDetail'
import BreadCrumb52 from '@/components/breadcrumb/HospitalDoctor'
import BreadCrumb53 from '@/components/breadcrumb/HospitalEncounter'
import BreadCrumb54 from '@/components/breadcrumb/HospitalProfile'
import BreadCrumb55 from '@/components/breadcrumb/HospitalPatients'
import BreadCrumb56 from '@/components/breadcrumb/Investigation'
import BreadCrumb57 from '@/components/breadcrumb/Diagnosis'
import BreadCrumb58 from '@/components/breadcrumb/Surgery'
import BreadCrumb59 from '@/components/breadcrumb/Symptoms'
import BreadCrumb60 from '@/components/breadcrumb/GeneralAdvice'
import BreadCrumb61 from '@/components/breadcrumb/Hospital'
import BreadCrumb62 from '@/components/breadcrumb/OnBoarding'
import BreadCrumb63 from '@/components/breadcrumb/VideoLibrary'
import BreadCrumb64 from '@/components/breadcrumb/traininglibrary'
import BreadCrumb65 from '@/components/breadcrumb/MyServices'
import BreadCrumb66 from '@/components/breadcrumb/Referal'
import BreadCrumb67 from '@/components/breadcrumb/AccountDetails'
import Pagination from  './components/kneexpert/Pagination.vue'

import { AuthMixin } from './router/authenticate';
// import LayoutHeader2 from '@/components/kneexpert/layouts/Header2' 

let Bootstrap = require('bootstrap')
import 'bootstrap/dist/css/bootstrap.css'



if(window.location.pathname.includes("harmacyadmin")) {
  require('./assets/PharmacyAdminStyle.css');
} else if(window.location.pathname.includes("/admin")) {
  require('./assets/AdminStyle.css');
}else if(!window.location.pathname.includes("/admin") && !window.location.pathname.includes("/pharmacyadmin")) {
  require('./assets/style.css');
}
import 'vue-select/dist/vue-select.css';

import './assets/plugins/fontawesome/css/fontawesome.min.css'
import './assets/plugins/fontawesome/css/all.min.css'
import Slick from 'vue-slick'
import '../node_modules/slick-carousel/slick/slick.css'
import Raphael from 'raphael/raphael'
global.Raphael = Raphael
Vue.config.productionTip = false

/*Global Components */
Vue.component('layout-header', LayoutHeader);
Vue.component('header-admin', HeaderAdmin);
Vue.component('sidebar', Sidebar);
Vue.component('sidebar1', Sidebar1);
Vue.component('sidebar2', Sidebar2);
Vue.component('layout-footer', LayoutFooter);
Vue.component('home-banner', HomeBanner);
Vue.component('specialities', Specialities);
Vue.component('bodypart', Bodypart);
Vue.component('cat', Cat);
Vue.component('slick', Slick);
Vue.component('loader', Loader);

/* BreadCrumbs */
Vue.component('breadcrumb', BreadCrumb);
Vue.component('breadcrumb1', BreadCrumb1);
Vue.component('breadcrumb2', BreadCrumb2);
Vue.component('breadcrumb3', BreadCrumb3);
Vue.component('breadcrumb4', BreadCrumb4);
Vue.component('breadcrumb5', BreadCrumb5);
Vue.component('breadcrumb6', BreadCrumb6);
Vue.component('breadcrumb7', BreadCrumb7);
Vue.component('breadcrumb8', BreadCrumb8);
Vue.component('breadcrumb9', BreadCrumb9);
Vue.component('breadcrumb10', BreadCrumb10);
Vue.component('breadcrumb11', BreadCrumb11);
Vue.component('breadcrumb12', BreadCrumb12);
Vue.component('breadcrumb13', BreadCrumb13);
Vue.component('breadcrumb14', BreadCrumb14);
Vue.component('breadcrumb15', BreadCrumb15);
Vue.component('breadcrumb16', BreadCrumb16);
Vue.component('breadcrumb17', BreadCrumb17);
Vue.component('breadcrumb18', BreadCrumb18);
Vue.component('breadcrumb19', BreadCrumb19);
Vue.component('breadcrumb20', BreadCrumb20);
Vue.component('breadcrumb21', BreadCrumb21);
Vue.component('breadcrumb22', BreadCrumb22);
Vue.component('breadcrumb23', BreadCrumb23);
Vue.component('breadcrumb24', BreadCrumb24);
Vue.component('breadcrumb25', BreadCrumb25);
Vue.component('breadcrumb26', BreadCrumb26);
Vue.component('breadcrumb27', BreadCrumb27);
Vue.component('breadcrumb28', BreadCrumb28);
Vue.component('breadcrumb29', BreadCrumb29);
Vue.component('breadcrumb30', BreadCrumb30);
Vue.component('breadcrumb31', BreadCrumb31);
Vue.component('breadcrumb32', BreadCrumb32);
Vue.component('breadcrumb33', BreadCrumb33);
Vue.component('breadcrumb34', BreadCrumb34);
Vue.component('breadcrumb35', BreadCrumb35);
Vue.component('breadcrumb36', BreadCrumb36);
Vue.component('breadcrumb37', BreadCrumb37);
Vue.component('breadcrumb38', BreadCrumb38);
Vue.component('breadcrumb39', BreadCrumb39);
Vue.component('breadcrumb40', BreadCrumb40);
Vue.component('breadcrumb41', BreadCrumb41);
Vue.component('breadcrumb42', BreadCrumb42);
Vue.component('breadcrumb43', BreadCrumb43);
Vue.component('breadcrumb44', BreadCrumb44);
Vue.component('breadcrumb45', BreadCrumb45);
Vue.component('breadcrumb46', BreadCrumb46);
Vue.component('breadcrumb47', BreadCrumb47);
Vue.component('breadcrumb48', BreadCrumb48);
Vue.component('breadcrumb49', BreadCrumb49);
Vue.component('breadcrumb50', BreadCrumb50);
Vue.component('breadcrumb51', BreadCrumb51);
Vue.component('breadcrumb52', BreadCrumb52);
Vue.component('breadcrumb53', BreadCrumb53);
Vue.component('breadcrumb54', BreadCrumb54);
Vue.component('breadcrumb55', BreadCrumb55);
Vue.component('breadcrumb56', BreadCrumb56);
Vue.component('breadcrumb57', BreadCrumb57);
Vue.component('breadcrumb58', BreadCrumb58);
Vue.component('breadcrumb59', BreadCrumb59);
Vue.component('breadcrumb60', BreadCrumb60);
Vue.component('breadcrumb61', BreadCrumb61);
Vue.component('breadcrumb62', BreadCrumb62);
Vue.component('breadcrumb63', BreadCrumb63);
Vue.component('breadcrumb64', BreadCrumb64);
Vue.component('breadcrumb65', BreadCrumb65);
Vue.component('breadcrumb66', BreadCrumb66);
Vue.component('breadcrumb67', BreadCrumb67);
Vue.component('pagination', Pagination);







Vue.use(VueSweetalert2);
Vue.mixin(AuthMixin);

new Vue({
  el: '#app',
  router,
  store,
  components: { App,BarChart,
    LineChart, },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js